export const CUSTOM_PAGINATION_PER_PAGE = 50;
export const SUGGESTIONS_PAGINATION_PER_PAGE = 20;
export const RECOMMENDED_SUGGESTIONS_PAGINATION_PER_PAGE = 8;
